import { render, staticRenderFns } from "./InformacionGeneral.vue?vue&type=template&id=3adc45e2"
import script from "./InformacionGeneral.vue?vue&type=script&lang=js"
export * from "./InformacionGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports